import { ColumnConfig } from "components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const USED_BY_COLUMNS_STORAGE_KEY = "usedByColumnsConfig";
export const FILTERS_ORDER_SETTINGS_KEY = "usedByFiltersOrder";

export const initialSortOption = "name";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export enum USED_BY_COLUMN_ID {
  TYPE = "TYPE",
  NAME = "NAME",
  SPACE = "SPACE",
  DELETE_ACTION = "DELETE_ACTION",
}

export const ROW_HEADER_ID = USED_BY_COLUMN_ID.NAME;

const MAX_CELL_WIDTH = 600;

export const USED_BY_COLUMN_CONFIG: ColumnConfig = {
  [USED_BY_COLUMN_ID.TYPE]: {
    title: "Type",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: false,
    static: true,
  },

  [USED_BY_COLUMN_ID.NAME]: {
    title: "Name",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: false,
    static: true,
  },

  [USED_BY_COLUMN_ID.SPACE]: {
    title: "Space",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: false,
    static: true,
  },
};

export const USED_BY_CUSTOM_END_COLUMN_CONFIG: ColumnConfig = {
  [USED_BY_COLUMN_ID.DELETE_ACTION]: {
    title: "Delete action",
    noHeader: true,
    static: true,
    maxWidth: 60,
    minWidth: 60,
    width: 60,
    sticky: true,
    resizable: false,
  },
};

export const SORT_CONFIG: Record<string, string> = {
  [USED_BY_COLUMN_ID.TYPE]: "type",
  [USED_BY_COLUMN_ID.NAME]: "name",
  [USED_BY_COLUMN_ID.SPACE]: "space",
};

export const INITIAL_COLUMNS_VIEW_CONFIG = {
  visible: Object.keys(USED_BY_COLUMN_CONFIG) as USED_BY_COLUMN_ID[],
  hidden: [],
};
